import { Plugin, PluginKey } from 'prosemirror-state'
import { Fragment, Node, Slice } from 'prosemirror-model'

import { MAX_LIST_DEPTH } from 'prose-core'

const CoerceListsPluginKey = new PluginKey('CoerceLists')

// This plugin checks if a list gets pasted into an empty list item and if yes,
// it preserves the indentation of the empty list item into the list at the
// beginning of the pasted content.
//
// # Example
// Image we copied a list item with no indentation "* abc". If we paste it in
// the following doc at the empty list item:
// * text
//   *
// We would get:
// * text
//   * abc
// Instead of:
// * text
// * abc
// NOTE: THe plugin preserves any content after the first list as is.
export const CoerceLists = new Plugin({
  key: CoerceListsPluginKey,
  props: {
    handlePaste: (view, event, slice) => {
      const {
        state: {
          schema,
          selection: { $from, empty },
        },
      } = view

      if (!empty) return false

      // NOTE: step 1: check prerequisites
      const maybeListItemNode = $from.node($from.depth - 1)
      if (!maybeListItemNode) return false
      if (maybeListItemNode.type !== schema.nodes.list_item || maybeListItemNode.nodeSize !== 4) return false
      if (!slice.content.firstChild?.type.groups.includes('list')) return false
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (maybeListItemNode.attrs.depth === slice.content.firstChild!.attrs.depth) return false

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const maybePastedListItemNode = slice.content.firstChild!.firstChild!
      if (!maybePastedListItemNode) return false

      // NOTE: step 2: construct new list, based on difference between first pasted item and item at paste position
      const difference = maybeListItemNode.attrs.depth - maybePastedListItemNode.attrs.depth
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const pastedList = slice.content.firstChild!
      const newListItems: Node[] = []
      pastedList.content.forEach((listItem) => {
        newListItems.push(
          listItem.type.create(
            { ...listItem.attrs, depth: Math.max(Math.min(listItem.attrs.depth + difference, MAX_LIST_DEPTH), 0) },
            listItem.content,
            listItem.marks,
          ),
        )
      })

      const content = Fragment.from([
        pastedList.copy(Fragment.from(newListItems)),
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...slice.content.cut(pastedList.nodeSize).content!,
      ])

      // NOTE: step 3: replace the empty list item at paste position with the adjusted list and rest of the content
      const newSlice = new Slice(content, slice.openStart, slice.openEnd)
      view.dispatch(view.state.tr.replace($from.before($from.depth - 1), $from.after($from.depth - 1), newSlice))

      return true
    },
  },
})
